// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/building.js';

import { paths } from '../generated/building';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('building', Original, paths);
